module.exports = __webpack_public_path__ + "static/media/inactivated-virus.73567e0b.jpg";